import { motion, useReducedMotion } from "motion/react";
import type { ComponentPropsWithoutRef } from "react";

import { EASE_OUT_STRONG } from "./constants";

/**
 * Stagger child with a prominent entrance: fade-up with slight scale.
 * Must be a direct child of AnimatedContainer for stagger timing to apply.
 * Pass initial="hidden" animate="visible" when used standalone.
 */
export function AnimatedCard(
  props: ComponentPropsWithoutRef<typeof motion.div>,
) {
  const shouldReduceMotion = useReducedMotion();

  const variants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 16,
      scale: shouldReduceMotion ? 1 : 0.97,
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: shouldReduceMotion ? 0 : 0.26,
        ease: EASE_OUT_STRONG,
      },
    },
  };

  return <motion.div variants={variants} {...props} />;
}
